import { Toast, Tooltip, Carousel } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

  // * Carousel initialization, remove it if not necessary
  document
    .querySelectorAll('.carousel')
    .forEach((carouselElement) => new Carousel(carouselElement, {
      ride: 'carousel',
      interval: 3500
    }));
})();
